module.exports = __webpack_public_path__ + "img/11.7fd12217.jpg";